import { Plus, ScanSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';

type ComponentsHeroProps = {
  onDetectRepo: () => void;
  onOnboard: () => void;
};

const ComponentsHero = ({ onDetectRepo, onOnboard }: ComponentsHeroProps) => {
  return (
    <header className="flex w-full min-w-0 items-start justify-between gap-8 max-md:flex-col max-md:gap-5">
      <div className="min-w-0 w-full max-w-[36rem]">
        <div className="mb-3 inline-flex items-center gap-2.5 text-[0.6875rem] font-semibold uppercase tracking-[0.16em] text-[var(--inv-accent)]">
          <span
            className="h-[2px] w-5 rounded-full bg-[var(--inv-accent)]"
            aria-hidden="true"
          />
          Inventory
        </div>

        <h1 className="m-0 mb-3 break-words font-serif text-[clamp(1.6rem,5vw,2.5rem)] font-medium leading-[1.1] tracking-[-0.015em] text-[var(--inv-text)]">
          Your{' '}
          <em className="italic text-[var(--inv-accent)]">repositories</em>, at a
          glance.
        </h1>

        <p className="m-0 max-w-[34rem] text-[0.875rem] font-normal leading-[1.55] text-[var(--inv-text-secondary)]">
          Each repo is scanned for size and coverage, and
          tracked here. Hover over a card for an overview, or click it to
          get the full details.
        </p>
      </div>

      <div className="mt-7 flex w-full min-w-0 shrink-0 flex-col items-stretch gap-2.5 sm:flex-row sm:items-center md:mt-7 md:w-auto md:flex-row">
        <Button
          type="button"
          variant="outline"
          onClick={onDetectRepo}
          className="h-10 w-full rounded-[10px] px-4 text-[0.8125rem] text-[var(--inv-text)] sm:w-auto md:w-auto">
          <ScanSearch className="h-4 w-4 shrink-0" strokeWidth={2.25} aria-hidden="true" />
          Detect Repo
        </Button>
        <Button
          type="button"
          onClick={onOnboard}
          className="h-10 w-full rounded-[10px] px-4 text-[0.8125rem] sm:w-auto md:w-auto">
          <Plus className="h-4 w-4 shrink-0" strokeWidth={2.25} aria-hidden="true" />
          Add repository
        </Button>
      </div>
    </header>
  );
};

export default ComponentsHero;
